/* Fine formula (confirmed): counted = max(0, daysLate − grace); daily → start + amount×counted; fixed → start + amount; capped by max. */
export const computeFine = (v, daysLate) => {
  const counted = Math.max(0, Number(daysLate || 0) - Number(v?.grace_days || 0));
  if (counted <= 0) return 0;
  const start = Number(v?.start_fee ?? 0) || 0;
  const amount = Number(v?.amount || 0);
  let fee = start + (v?.mode === 'daily' ? amount * counted : amount);
  const cap = v?.max_fee;
  if (cap !== null && cap !== undefined && cap !== '' && Number(cap) > 0 && fee > Number(cap)) fee = Number(cap);
  return Math.floor(fee * 100) / 100;
};

export const fineExampleText = (v, isAr) => {
  const g = Number(v?.grace_days || 0);
  const d = g + 3;
  const fee = computeFine(v, d);
  return isAr
    ? `مثال: تأخير ${d} يوم (المهلة ${g} يوم → ${d - g} أيام محتسبة) = ${fee.toLocaleString()} د.إ`
    : `Example: ${d} days late (grace ${g} → ${d - g} counted days) = ${fee.toLocaleString()} AED`;
};

export const modeLabel = (mode, isAr) => (mode === 'fixed' ? (isAr ? 'مبلغ ثابت' : 'Fixed amount') : (isAr ? 'يومي' : 'Daily'));
